<template>
<div>
  <div class="eval-form">
		<!-- <div class="flex align-center ft-24 pb-30 b-b mb-40"> -->
			<!-- <div class="c-a8 mr-10 ">业务名称：</div>
			<div class="c-66 mr-30 flex-1">{{ticketInfo.bizName}}</div>
			<div class="c-a8 mr-10 ">票号：</div>
			<div class="c-66 flex-1">{{ticketInfo.ticketNo}}</div> -->
			<van-row  class=" ft-24 pb-30 b-b mb-40">
				<van-col span="5" class="c-a8">业务名称：</van-col>
				<van-col span="12" class="c-66">{{ticketInfo.bizName}}</van-col>
				<van-col span="3" class="c-a8">票号：</van-col>
				<van-col span="4" class="c-66">{{ticketInfo.ticketNo}}</van-col>
			</van-row>
		<!-- </div> -->
		<van-row type="flex" align="center" class="mb-40">
			<van-col class="ft-30 c-black" span="6">服务评价</van-col>
			<van-col class="ft-30 c-black" span="18"
				><van-rate
					v-model="value"
					:size="25"
					color="#ffd21e"
					void-icon="star"
					void-color="#eee"
			/></van-col>
		</van-row>
		<van-field
			v-model="message"
			class='iconfont'
			:placeholder="placeholder"
			type="textarea"
		/>
	
  </div>
	 <div class="eval-btn">
      <van-button type="primary" color="#f5f5f5" class="blue-common-btn" block @click="bindSubmit">提交</van-button>
    </div>
</div>
</template>

<script>
import {  ticketDetail, addEval } from "@/api/index";
import { Toast } from 'vant';
export default {
	data() {
		return {
			message: '',
			value: 5,
			ticketInfo: {},
			placeholder: '请输入评价内容'
		}
	},
	created() {
		this.init();
	},
	methods: {
		init() {
      ticketDetail(
        this.$route.params.clientId,
        this.$route.query.ticketId
      ).then((res) => {
        this.ticketInfo = res.data;
      });
		},
		bindSubmit() {
			let params = {
				ticketId: this.$route.query.ticketId, 
				evalCode: this.value, 
				evalContent: this.message
			}
			addEval(params).then(res => {
				Toast.success('评价成功');
				this.$router.back()
			})
		}
	}
}
</script>

<style lang="scss" >
.eval-form {
	background-color: #fff;
	padding: 40px 30px;
	margin: 40px 40px 60px;
	border-radius: 16px;
}
textarea::-webkit-input-placeholder {
	font-family: 'iconfont';
}
.iconfont {
	padding:  0 ;
	font-size: 28px !important;
}
.eval-btn {
  margin: 60px 30px 0;
}
</style>
